export enum Module {
  MEMBER = 'member',
  ACCOUNT = 'account',
  PROGRAMS = 'programs',
  COURSES = 'courses',
  MANAGEMENT = 'management',
  CALENDAR = 'calendar'
}
